import script from "./FormDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDropdown.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./FormDropdown.vue?vue&type=style&index=1&id=637f6904&lang=css"

const __exports__ = script;

export default __exports__